// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"727":"1ecb231e","787":"0f56bde6"}[chunkId] + ".chunk.js";
};